'use client'

import { isNull } from 'lodash-es'

import { useRouter } from '@/shared/i18n'

export const ENTRY_HISTORY_LENGTH_KEY = 'entry_history_length'

export const useSafeBack = () => {
  const router = useRouter()

  const canGoBack = () => {
    const entryHistoryLength = sessionStorage.getItem(ENTRY_HISTORY_LENGTH_KEY)

    if (isNull(entryHistoryLength)) return false

    return window.history.length > Number(entryHistoryLength)
  }

  const goBack = (fallback = '/') => {
    if (!canGoBack()) {
      router.replace(fallback)

      return
    }

    router.back()
  }

  return { canGoBack, goBack }
}
